<bw-action-article-legacy [brightsideWebFb]="{ event_name: 'kyc_review_pending' }">
  <div content-section>
    <div class="mb-sm">
      <img src="../assets/hourglass.png" />
    </div>
    <div class="copy-wrapper">
      <typography-legacy title-medium class="mb-sm" color="var(--primary-text)">
        <div [innerHTML]="'KYC_REVIEW_PENDING_TITLE' | translate"></div>
      </typography-legacy>
      <typography-legacy text-medium-regular class="mb-md" color="var(--secondary-text)">
        <div [innerHTML]="'KYC_REVIEW_PENDING_DESC' | translate"></div>
      </typography-legacy>
    </div>
  </div>

  <div footer-actions>
    <div class="flex-row row-reverse">
      <button bw-button-legacy type="submit" (click)="redirectHome()" [brightsideWebFb]="{ event_name: 'kyc_review_pending' }">
        {{ 'KYC_REVIEW_PENDING_CTA' | translate }}
      </button>
    </div>
  </div>
</bw-action-article-legacy>
